import { Action } from '@ngrx/store';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { ICompanyMutation, IVacancyMutation } from '@interfaces/ICompany';

export enum ECompaniesChangesActions {
  CreateCompanyRequest = '[Companies changes] Create Company Request',
  CreateCompanySuccess = '[Companies changes] Create Company Success',
  CreateCompanyFailure = '[Companies changes] Create Company Failure',
  ClearCreateCompanies = '[Companies changes] Clear Create Companies',

  CreateVacancyRequest = '[Companies changes] Create Vacancy Request',
  CreateVacancySuccess = '[Companies changes] Create Vacancy Success',
  CreateVacancyFailure = '[Companies changes] Create Vacancy Failure',
  ClearCreateVacancies = '[Companies changes] Clear Create Vacancies',

  DeleteVacancyRequest = '[Companies changes] Delete Vacancy Request',
  DeleteVacancySuccess = '[Companies changes] Delete Vacancy Success',
  DeleteVacancyFailure = '[Companies changes] Delete Vacancy Failure',
  ClearDeleteVacancies = '[Companies changes] Clear Delete Vacancies',

  EditVacancyRequest = '[Companies changes] Edit Vacancy Request',
  EditVacancySuccess = '[Companies changes] Edit Vacancy Success',
  EditVacancyFailure = '[Companies changes] Edit Vacancy Failure',
  ClearEditVacancies = '[Companies changes] Clear Edit Vacancies',
}

export class CreateCompanyRequest implements Action {
  public readonly type = ECompaniesChangesActions.CreateCompanyRequest;
  constructor(public data: ICompanyMutation) {}
}

export class CreateCompanySuccess implements Action {
  public readonly type = ECompaniesChangesActions.CreateCompanySuccess;
}

export class CreateCompanyFailure implements Action {
  public readonly type = ECompaniesChangesActions.CreateCompanyFailure;
  constructor(public error: IFormErrors) {}
}

export class ClearCreateCompanies implements Action {
  public readonly type = ECompaniesChangesActions.ClearCreateCompanies;
}

export class CreateVacancyRequest implements Action {
  public readonly type = ECompaniesChangesActions.CreateVacancyRequest;
  constructor(public data: IVacancyMutation) {}
}

export class CreateVacancySuccess implements Action {
  public readonly type = ECompaniesChangesActions.CreateVacancySuccess;
}

export class CreateVacancyFailure implements Action {
  public readonly type = ECompaniesChangesActions.CreateVacancyFailure;
  constructor(public error: IFormErrors) {}
}

export class ClearCreateVacancies implements Action {
  public readonly type = ECompaniesChangesActions.ClearCreateVacancies;
}

export class DeleteVacancyRequest implements Action {
  public readonly type = ECompaniesChangesActions.DeleteVacancyRequest;
  constructor(public id: number) {}
}

export class DeleteVacancySuccess implements Action {
  public readonly type = ECompaniesChangesActions.DeleteVacancySuccess;
}

export class DeleteVacancyFailure implements Action {
  public readonly type = ECompaniesChangesActions.DeleteVacancyFailure;
  constructor(public error: IFormErrors) {}
}

export class ClearDeleteVacancies implements Action {
  public readonly type = ECompaniesChangesActions.ClearDeleteVacancies;
}

export class EditVacancyRequest implements Action {
  public readonly type = ECompaniesChangesActions.EditVacancyRequest;
  constructor(public id: number, public data: Partial<IVacancyMutation>) {}
}

export class EditVacancySuccess implements Action {
  public readonly type = ECompaniesChangesActions.EditVacancySuccess;
}

export class EditVacancyFailure implements Action {
  public readonly type = ECompaniesChangesActions.EditVacancyFailure;
  constructor(public error: IFormErrors) {}
}

export class ClearEditVacancies implements Action {
  public readonly type = ECompaniesChangesActions.ClearEditVacancies;
}

export type CompaniesChangesActions =
  | CreateCompanyRequest
  | CreateCompanySuccess
  | CreateCompanyFailure
  | ClearCreateCompanies
  | CreateVacancyRequest
  | CreateVacancySuccess
  | CreateVacancyFailure
  | ClearCreateVacancies
  | DeleteVacancyRequest
  | DeleteVacancySuccess
  | DeleteVacancyFailure
  | ClearDeleteVacancies
  | EditVacancyRequest
  | EditVacancySuccess
  | EditVacancyFailure
  | ClearEditVacancies;
